import React from 'react';

const LayoutPolicy = (props) => {
    const { children } = props;

    const confirmBtnClick = () => {
        window.history.back();
    };
    
    return (
        <>
            {/* contents */}
            <div className="contents">
                <div className="contents-new-agree privacy-policy">
                    { children }
                </div>
            </div>

            {/* footer */}
            <div className="footer fixed">
                <div className="footer-agree">
                    <button id="button-ok" type="button" className="button--text active" onClick={() => confirmBtnClick()}>
                        <span>확인</span>
                    </button>
                </div>
            </div>
        </>
    )
}

export default LayoutPolicy;
